export default {
    mounted() {
        this.checkOpenMenu();
        this.getLabel();
        this.lists.forEach((item) => {
            if (item.isSelected) {
                this.title = item.title;
            }
        });
    },
    methods: {
        getLabel() {},
        choiceItem(item) {
            this.title = item.title;
            this.showDropDown = false;
            this.navigateToUrl(item);
        },
        navigateToUrl(item) {
            if (!item.asLink) {
                return false;
            }

            window.location.href = item.urlHref;
        },
        toggleSelect() {
            this.showDropDown = !this.showDropDown;
        },
        onClickOutside() {
            this.showDropDown = false;
        },
        selectLabel() {
            this.title = this.label;
            this.showDropDown = false;
        },
        reset() {
            this.title = this.label;
        },
        checkOpenMenu() {
            const openersInternalMenu = document.querySelectorAll(
                '.js-menu-internal-opener'
            );
            openersInternalMenu.forEach((el) => {
                el.addEventListener('click', () => {
                    this.title = this.label;
                });
            });

            const openersBurgerMenu = document.querySelectorAll(
                '.js-menu-burger-opener'
            );
            openersBurgerMenu.forEach((el) => {
                el.addEventListener('click', () => {
                    this.title = this.label;
                });
            });
        },
        // Если есть поле item.isExternal, то открываем ссылку в новой вкладке
        checkItemTarget(item) {
            return item.isExternal ? '_blank' : null;
        },
    },
};
